import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['submitButton', 'otherButton'];

  // Do not intercept the submission: form.submit() drops the submitter, so the
  // clicked button's name (the last_offer_*_accept param the server records)
  // never reached the request. Letting the native submit run keeps it, and the
  // clicked button itself stays enabled so it is still sent.
  handleSubmit(event) {
    const clickedButton = event.submitter || event.target.querySelector('button[type="submit"]');
    this.selectOtherButtons(clickedButton);
  }

  handleClick(event) {
    const clickedButton = event.target;
    this.selectOtherButtons(clickedButton);
  }

  selectOtherButtons(clickedButton) {
    const otherButtons = this.otherButtonTargets.filter(button => button !== clickedButton);
    this.disableOtherButtons(otherButtons);

    const otherSubmitButtons = this.submitButtonTargets.filter(button => button !== clickedButton);
    this.disableOtherButtons(otherSubmitButtons);
  }

  disableOtherButtons(otherButtons) {
    otherButtons.forEach(button => { button.disabled = true; })
  }
}
